var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hl-Select',{attrs:{"size":"sm","value":_vm.value,"options":_vm.landlordOptions,"label":"Velg én utleierprofil","placeholder":"Velg utleierprofil","placeholderValue":"__NULL__"},on:{"input":function($event){return _vm.$emit('input', arguments[0])}}})
}
var staticRenderFns = []

export { render, staticRenderFns }